const hasFeature = require('./has_feature')
const try_features = require('module/try_before_buy/try_features')

module.exports = function isTryingPro(user) {
    // if they are pro, they are not trying pro
    if (hasFeature(user, 'upgrade')) return false

    // see if they have any of the try features
    return try_features.some((feature) => {
        return hasFeature(user, feature)
    })
}
